export default {
  Contributors: {
    select: 'id,collaboratorUserId',
    expand: {
      collaboratorUser: {
        select: 'userId,fullName,accessType',
      },
    },
  },
  Dependencies: {},
  Dependents: {},
};
